<template>
  <div class="container containerForm">
    <h2 style="text-align: center">إضافة قسم جديد</h2>
    <form @submit.prevent="addCategory">
      <div class="form-group">
        <label for="name_ar">الاسم بالعربية</label>
        <input
          type="text"
          class="form-control"
          id="name_ar"
          v-model="categoryData.name_ar"
          :class="{ 'is-invalid': errors.name_ar }"
        />
        <div v-if="errors.name_ar" class="invalid-feedback">
          {{ errors.name_ar }}
        </div>
      </div>
      <div class="form-group">
        <label for="name_en">الاسم بالإنجليزية</label>
        <input
          type="text"
          class="form-control"
          id="name_en"
          v-model="categoryData.name_en"
          :class="{ 'is-invalid': errors.name_en }"
        />
        <div v-if="errors.name_en" class="invalid-feedback">
          {{ errors.name_en }}
        </div>
      </div>
      <div class="form-group">
        <label for="image">صورة القسم</label>
        <input
          type="file"
          accept="image/*"
          class="form-control"
          id="image"
          @change="handleImageUpload"
        />
      </div>
      <button type="submit" class="btn btn-primary">حفظ</button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      categoryData: {
        name_ar: "",
        name_en: "",
        image: null,
      },
      errors: {
        name_ar: null,
        name_en: null,
      },
    };
  },
  methods: {
    addCategory() {
      this.resetErrors();

      if (!this.isFormValid()) return;

      const formData = new FormData();
      for (const key in this.categoryData) {
        formData.append(key, this.categoryData[key]);
      }

      Axios.post("/category", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.handleSuccessResponse(response);
        })
        .catch((error) => {
          this.handleErrorResponse(error);

        });
    },
    resetErrors() {
      this.errors = {
        name_ar: null,
        name_en: null,
      };
    },
    isFormValid() {
      const arabicLettersRegex = /^[\u0621-\u064A\s]+$/;
      const englishLettersRegex = /^[A-Za-z\s]+$/;

      if (!this.categoryData.name_ar) {
        this.errors.name_ar = "الرجاء إدخال الاسم بالعربية";
      } else if (!arabicLettersRegex.test(this.categoryData.name_ar)) {
        this.errors.name_ar = "الرجاء إدخال حروف عربية فقط";
      }

      if (!this.categoryData.name_en) {
        this.errors.name_en = "الرجاء إدخال الاسم بالإنجليزية";
      } else if (!englishLettersRegex.test(this.categoryData.name_en)) {
        this.errors.name_en = "الرجاء إدخال حروف إنجليزية فقط";
      }
      if (!this.categoryData.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الرجاء اختيار صورة القسم",
          position: "bottomRight",
        });
        return false;
      }
      return true;
    },
    handleSuccessResponse(response) {
      // console.log(response.data);
      this.clearForm();
      this.$iziToast.success({
        timeout: 2000,
        message: "تم إضافة القسم بنجاح",
        position: "bottomRight",
      });
      this.$router.push("/admin/categories");
    },
    handleErrorResponse(error) {
      // console.log(error.response);
      if (error.response && error.response.data) {
                const errorMessage = error.response.data.errors[0];
                this.$iziToast.error({
                  timeout: 5000,
                  message: errorMessage,
                  position: "bottomRight",
                });
              } else {
                this.$iziToast.error({
                  timeout: 2000,
                  message: "فشل الإضافة",
                  position: "bottomRight",
                });
              }
    },
    clearForm() {
      this.categoryData = {
        name_ar: "",
        name_en: "",
        image: null,
      };
    },
    handleImageUpload(event) {
      const selectedImage = event.target.files[0];
      if (selectedImage) {
        this.categoryData.image = selectedImage;
      }
    },
  },
};
</script>